import React from 'react';
import { Space, Typography } from '@svg/antd';
import { useIntl } from '@umijs/max';
import { TextOverflowTooltip } from '@svg/antd-cloud-design'

const { Text } = Typography;

interface EmptyStateProps {
  onSelect?: (searchValue: string, select: any, type: string) => void;
  searchHistory?: string[];
  hotSearch?: string[];
  onClearHistory?: () => void;
  size?: 'large' | 'normal'
}

const EmptyState: React.FC<EmptyStateProps> = ({ onSelect, searchHistory = [], hotSearch = [], onClearHistory, size }) => {
  const { formatMessage } = useIntl();

  const handleSelect = (value: string, type: string = 'history') => {
    if (onSelect) {
      onSelect(value, value, type);
    }
  };

  const handleClearHistory = () => {
    if (onClearHistory) {
      onClearHistory();
    }
  };

  const isNonZhCNLanguage = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get('lang');
    return lang && lang !== 'zh-CN';
  };

  return (
    <div className="dropdown-container">
      {/* 搜索历史 */}
      {searchHistory.length > 0 && (
        <>
          <div className="search-history-section">
            <div className="section-title">
              <Space size={4}>
                <Text>{formatMessage({ id: '最近搜索' })}</Text>
              </Space>
              <i className="material-iconfont icon-delete1" onClick={handleClearHistory}></i>
            </div>
            <Space wrap size={size === 'normal' ? [12, 12] : [12, 12]}>
              {searchHistory.map((item) => (
                <TextOverflowTooltip key={item}>
                  <div
                    className="hot-tag"
                    onMouseDown={(e) => {
                      e.preventDefault();
                      handleSelect(item, 'searchHistory');
                    }}
                  >
                    {item}
                  </div>
                </TextOverflowTooltip>
              ))}
            </Space>
          </div>
        </>
      )}

      {/* 热搜 */}
      {hotSearch.length > 0 && (
        <div className="hot-search-section">
          <div className="section-title">
            {/* <Space size={4}>
              <Text>{formatMessage({ id: '热搜' })}</Text>
            </Space> */}
            {isNonZhCNLanguage() ? (
              <span>
                {formatMessage({ id: '热搜' })}
              </span>
            ) : <img src="https://3vj-fe.oss-cn-shenzhen.aliyuncs.com/project/material/img/Union.svg" alt="" />}
            <img src="https://3vj-fe.oss-cn-shenzhen.aliyuncs.com/project/material/img/fire.svg" alt="" />
          </div>
          <Space wrap size={size === 'normal' ? [12, 12] : [12, 12]}>
            {hotSearch.map((item) => (
              <TextOverflowTooltip key={item}>
                <div
                  className="hot-tag"
                  onMouseDown={(e) => {
                    e.preventDefault();
                    handleSelect(item, 'hotSearch');
                  }}
                >
                  {item}
                </div>
              </TextOverflowTooltip>
            ))}
          </Space>
        </div>
      )
      }
    </div >
  );
};

export default EmptyState;
